import { Character } from "./Character";
import TranslateApi from "src/utils/TranslateHelper";

/**
 * Represents an option in the game (a button)
 * Each option can take you to a different scene and will change what's going to happen in the game later on
 */
export class DialogOption {
    public id: number;
    public textKey: string;
    public nextSlideID: number; // ID of the next slide if you choose this option
}

export class GameState {
    public currentSlideID: number;
    public slideOptions: DialogOption[];
    public slideDialog: string;
    public slideCharacter: Character;
    public isLoaded: boolean;


    /**
     * Reference to the current game state at all times
     * Dynamically changes!
     */
    public static current: GameState;

    constructor(character: Character, dialogKey: string, options: DialogOption[]) {
        this.currentSlideID = 1;
        this.slideCharacter = character;
        this.slideDialog = TranslateApi.translate(dialogKey);
        this.slideOptions = options;
        this.isLoaded = false;
    }
}



// WEBPACK FOOTER //
// ./src/games/ColonyGame/objects/GameState.ts